var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import styles from './index.scss';
const AnchorLink = (_a) => {
    var { children, newWindow, className = '' } = _a, props = __rest(_a, ["children", "newWindow", "className"]);
    const target = newWindow ? '_blank' : undefined;
    return (React.createElement("a", Object.assign({ className: classNames(styles.anchor, className), target: target }, props), children));
};
export default AnchorLink;
//# sourceMappingURL=index.js.map